import { useReferralCode } from '@src/hooks/useReferrals';
import {
  buttonVariants,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Text,
  VStack,
} from 'ui_2';
import { BiGroup } from 'react-icons/bi';
import { ReferralCode } from '../referral/ReferralCode';

export const ShareUsername = () => {
  const { data } = useReferralCode();

  return (
    <Dialog>
      <DialogTrigger
        className={buttonVariants({
          variant: 'black',
          className: 'w-fit min-w-[120px] items-center gap-2',
          size: 'md',
        })}
      >
        <BiGroup />
        <Text font='sm' color='white'>
          Invite Friends
        </Text>
      </DialogTrigger>
      <DialogContent
        className='max-w-[min(90%,400px)]'
        aria-describedby={undefined}
      >
        <DialogTitle>
          <Text font='bold-md'>Invite Friends</Text>
        </DialogTitle>
        <DialogClose />
        <VStack className='gap-6'>
          <VStack className='gap-2'>
            <Text font='medium-md'>Your Username</Text>
            <Text className='mb-3 text-sm text-gray-600'>
              Share your username with friends. Both of you need to add each
              other to become friends.
            </Text>
            <ReferralCode
              shareTitle='🌟 Join my Puzzle Arcade crew!'
              shareText={`🚀 Add me as a friend on Puzzle Arcade and let's play together!\n\nUse my username: "${data?.referralCode}"`}
              friendUsername={true}
            />
          </VStack>
        </VStack>
      </DialogContent>
    </Dialog>
  );
};
